import script from "./noticeHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./noticeHistory.vue?vue&type=script&setup=true&lang=js"

import "./noticeHistory.vue?vue&type=style&index=0&id=380f5a8d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-380f5a8d"]])

export default __exports__